
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate/failure",
      function () {
        return require("private-next-pages/activate/failure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate/failure"])
      });
    }
  